import React, {createContext, useContext, useState} from "react";
import {DeviceDetailRepository} from "../../repository/AdminDashboard/DeviceList_Repository";
import {useNavigate} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import Icon from "../../components/atoms/Icon";
import {API_BASE_URL} from "../../clases/request";

const StateContext = createContext();

const initialState = {};

const DeviceDetailContext = ({children}) => {
    const [id, setid] = useState("");
    const [Modelname, setModelname] = useState("");
    const [SerialNumber, setSerialNumber] = useState("");
    const [ProductionDate, setProductionDate] = useState("");
    const [brokerPass, setbrokerPass] = useState("");
    const [DateFirstConnection, setDateFirstConnection] = useState("");
    const [lastStatus, setlastStatus] = useState("");
    const [name, setname] = useState("");
    const [phoneNumber, setphoneNumber] = useState("");
    const [city, setcity] = useState("");
    const [grantiNumber, setgrantiNumber] = useState("");
    const [grantiDeadTime, setgrantiDeadTime] = useState("");
    const [grantiUsedStatus, setgrantiUsedStatus] = useState("");
    const [puchaseDate, setpuchaseDate] = useState("");
    const [ActivatingUser, setActivatingUser] = useState("");
    const [activationDate, setactivationDate] = useState("");
    const [guest, setguest] = useState([]);
    const [loaded, setloaded] = useState(false);
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const [showDeletebroker, setshowDeletebroker] = useState(false);
    const [pin, setpin] = useState("");
    const [barcodeAddress, setBarcodeAddress] = useState("");

    // Navigation hook
    const navigate = useNavigate();

    // Function to fetch device details
    const getdeviceDetail = async (id_data) => {
        setloaded(true);
        const data = await DeviceDetailRepository.getdeviceDetail(id_data);
        const token = localStorage.getItem("token");
        if (data.code == 1) {
            // Set device details
            setid(data.detail.id);
            setModelname(data.detail.Modelname);
            setSerialNumber(data.detail.SerialNumber);
            setProductionDate(data.detail.ProductionDate);
            setbrokerPass(data.detail.brokerPass);
            setDateFirstConnection(data.detail.DeteFirstConnection);
            setlastStatus(data.detail.lastStatus);
            setname(data.detail.name);
            setphoneNumber(data.detail.phoneNumber);
            setcity(data.detail.city);
            setgrantiNumber(data.detail.grantiNumber);
            setgrantiUsedStatus(data.detail.grantiUsedStatus);
            setpuchaseDate(data.detail.puchaseDate);
            setActivatingUser(data.detail.ActivatingUser);
            setactivationDate(data.detail.activationDate);
            setgrantiDeadTime(data.detail.grantiDeadTime);
            setguest(data.guest);
            setpin(data.detail.pin);
            const link = `${API_BASE_URL}/store-house/get-label/${data.detail.SerialNumber}/${token}`;
            setBarcodeAddress(link);
        } else if (data.code == 0) {
            // Redirect to previous page if data retrieval fails
            navigate(-1);
            // Show error toast
            return toast.error(data.message, {
                className: "text-12 text-dark-blue-200",
            });
        }

        setloaded(false);
    };

    // Function to delete broker
    const getdeleteBroker = async () => {
        const data = await DeviceDetailRepository.getdeleteBroker(id);
        if (data.code == 1) {
            toast.success(data.massage, {
                className: "text-12 text-dark-blue-200",
            });
            await getdeviceDetail();
        } else if (data.code == 0) {
            toast.error(data.massage, {
                className: "text-12 text-dark-blue-200",
            });
        }
    };

    // Function to delete device
    const deleteِDevice = async () => {
        const data = await DeviceDetailRepository.deleteDevice(id);
        if (data.code == 1) {
            navigate("/device/list/");
            setTimeout(() => {
                toast.success(data.massage, {
                    className: "text-12 text-dark-blue-200",
                });
            }, 1000);
        } else if (data.code == 0) {
            toast.error(data.massage, {
                className: "text-12 text-dark-blue-200",
            });
        }
    };
    const barcodeDownloadClick = () => {
        const token = localStorage.getItem("token");
        const link = `${API_BASE_URL}/store-house/get-label/${SerialNumber}/${token}`;

        return (
            <a
                href={link}
                download={"kimia.png"}>
            </a>
        )

    }

    // Function to navigate to action log
    const actionlog = () => {
        navigate(`/admin/device/list/log?id=${id}`);
    };

    // Function to handle broker deletion, open modal
    const onDeleteBroker = () => {
        setshowDeletebroker(true);
    };

    // Function to close broker deletion modal
    const closeDeleteBroker = () => {
        setshowDeletebroker(false);
    };

    // Function to remove broker
    const RemoveBroker = async () => {
        setshowDeletebroker(false);
        await getdeleteBroker();
    };

    // Function to handle device deletion
    const onDelete = () => {
        setshowDeleteModal(true);
    };

    // Function to close device deletion modal
    const closeDeleteModal = () => {
        setshowDeleteModal(false);
    };

    // Function to remove device
    const RemoveItem = async () => {
        setshowDeleteModal(false);
        await deleteِDevice(id);
    };

    return (
        <StateContext.Provider
            value={{
                getdeviceDetail,
                id,
                Modelname,
                SerialNumber,
                ProductionDate,
                brokerPass,
                DateFirstConnection,
                lastStatus,
                name,
                phoneNumber,
                city,
                grantiNumber,
                grantiUsedStatus,
                puchaseDate,
                ActivatingUser,
                activationDate,
                grantiDeadTime,
                guest,
                loaded,
                actionlog,
                onDeleteBroker,
                RemoveItem,
                closeDeleteModal,
                onDelete,
                showDeleteModal,
                showDeletebroker,
                closeDeleteBroker,
                RemoveBroker,
                pin,
                barcodeAddress
            }}>
            {children}
        </StateContext.Provider>
    );
};

function DeviceDetailUseContext() {
    return React.useContext(StateContext);
}

export default DeviceDetailContext;
export {DeviceDetailUseContext};
